import { Link } from "react-router-dom";
import { topics } from "@/mocks/news";

export default function TopicPicks() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
      {topics.map((topic) => (
        <Link
          key={topic.title}
          to={`/search?q=${encodeURIComponent(topic.tag)}`}
          className="group relative rounded-lg overflow-hidden h-52 md:h-60 cursor-pointer"
        >
          <img
            src={topic.cover}
            alt={topic.title}
            title={`${topic.title} - 吃瓜爆料网`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/92 via-secondary-950/45 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
            <span className="inline-block px-2 py-0.5 rounded-md bg-accent-500 text-secondary-950 text-xs font-medium mb-2">
              {topic.tag}
            </span>
            <h3 className="text-lg font-bold text-background-50 leading-snug">{topic.title}</h3>
            <p className="mt-1.5 text-xs text-background-200 leading-relaxed line-clamp-2">{topic.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}